import { render, staticRenderFns } from "./no-data.vue?vue&type=template&id=8ba47eee&scoped=true"
import script from "./no-data.vue?vue&type=script&lang=js"
export * from "./no-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_ec1e824a4fe600ca080e24d3f05cd390/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba47eee",
  null
  
)

export default component.exports